import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from '@mui/material/styles';

//const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

const cards = [
  {
    id: 1,
    pageId: 'school/salary-trends',
    image: 'https://source.unsplash.com/random',
    title: 'School Salary Trends',
    desc: 'Chart displaying salary trends across multiple positions in a school district',
  },
  {
    id: 2,
    pageId: 'school/enrollment',
    image: 'https://source.unsplash.com/random',
    title: 'School Enrollment Trends',
    desc: 'Chart to compare school district enrollment trends across multiple school districts',
  },
  {
    id: 3,
    pageId: 'city/city-taxes',
    image: 'https://source.unsplash.com/random',
    title: 'City Taxes',
    desc: 'Table of taxes rate for cities in Van Zandt, Wood, Smith, Kaufman and Rains counties',
  },
];

const theme = createTheme();

export default function Home() {
  return (
    <ThemeProvider theme={theme}>
      <main>
        {/* Hero unit */}
        <Box
          sx={{
            bgcolor: 'background.paper',
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth='sm'>
            <Typography component='h1' variant='h2' align='center' color='text.primary' gutterBottom>
              Texas School and City Data Engine
            </Typography>
            <Typography variant='h5' align='center' color='text.secondary' paragraph>
              A collection of report and charts for various dataset for school districts and city related information. The dataset used on this page are sourced directly from the TEA and Texas
              Comptroller webpages.
            </Typography>
            {/* <Stack sx={{ pt: 4 }} direction='row' spacing={2} justifyContent='center'>
              <Button variant='contained'>Main call to action</Button>
              <Button variant='outlined'>Secondary action</Button>
            </Stack> */}
          </Container>
        </Box>
        <Container sx={{ py: 8 }} maxWidth='md'>
          {/* End hero unit */}
          <Grid container spacing={4}>
            {cards.map((card) => (
              <Grid item key={card.id} xs={12} sm={6} md={4}>
                <Card>
                  <CardMedia image={card.image} title={card.title} />
                  <CardContent>
                    <Typography gutterBottom variant='h5' component='h2'>
                      {card.title}
                    </Typography>
                    <Typography>{card.desc}</Typography>
                  </CardContent>
                  <CardActions>
                    {card.pageId && (
                      <Button size='small' color='primary' href={'/' + card.pageId}>
                        Details
                      </Button>
                    )}
                    {card.pageIdSummary && (
                      <Button size='small' color='primary' href={'./' + card.pageIdSummary}>
                        Summary
                      </Button>
                    )}
                    {card.pageIdChart && (
                      <Button size='small' color='primary' href={'./' + card.pageIdChart}>
                        Chart
                      </Button>
                    )}
                    {card.pageIdDiagram && (
                      <Button size='small' color='primary' href={'./' + card.pageIdDiagram}>
                        Diagrams
                      </Button>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
          {/*  <Grid container spacing={4}>
            {cards.map((card) => (
              <Grid item key={card} xs={12} sm={6} md={4}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardMedia
                    component='img'
                    sx={{
                      // 16:9
                      pt: '56.25%',
                    }}
                    image='https://source.unsplash.com/random'
                    alt='random'
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant='h5' component='h2'>
                      Heading
                    </Typography>
                    <Typography>This is a media card. You can use this section to describe the content.</Typography>
                  </CardContent>
                  <CardActions>
                    <Button size='small'>View</Button>
                    <Button size='small'>Edit</Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid> */}
        </Container>
      </main>
    </ThemeProvider>
  );
}
